import React from "react";
import { makeStyles } from "tss-react/mui";
import { Button } from "../button/Buttons.js";
import "../button/EditButton.js";
import "../../localization/MessageLocalizer.js";
import "../../localization/LocaleProvider.js";
import { sharedLocalization } from "../../localization/sharedResources.js";
const useClasses = makeStyles()((theme) => ({
  multiStepFilterApplyButtonContainer: {
    padding: theme.spacing(1.5)
  },
  multiStepFilterApplyButton: {
    borderRadius: theme.spacing(1)
  }
}));
function MultiStepFilterApplyButton({ onApply }) {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement("div", { className: classes.multiStepFilterApplyButtonContainer }, /* @__PURE__ */ React.createElement(
    Button,
    {
      fullWidth: true,
      className: classes.multiStepFilterApplyButton,
      label: sharedLocalization.apply,
      color: "primary",
      onClick: onApply
    }
  ));
}
export {
  MultiStepFilterApplyButton
};
//# sourceMappingURL=MultiStepFilterApplyButton.js.map
